import { CustomerIndexViewModel, TenantViewModel } from '@ail/customers-api'
import { ContractState, OrdersFormViewModel } from '@ail/orders-api'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { getFormTitle } from '../../../helpers/Orders'
import { useContractSupport } from '../../../hooks/useContractSupport'
import { useSettings } from '../../../hooks/useSettings'
import { IUserViewModel } from '../../../types/interfaces'
import { Orders } from '../../../utils/orders'
import { GridRow } from '../GeneralContractsFunctional'
interface Props {
  user?: IUserViewModel | null
  allOrdersForms?: OrdersFormViewModel[]
  allTenants?: TenantViewModel[]
  filteredCustomers?: CustomerIndexViewModel[]
  row: GridRow
}
export default function ContractCell({ user, allOrdersForms, allTenants, filteredCustomers, row }: Props) {
  const { t, i18n } = useTranslation('common')
  const { setContractSupportRef } = useContractSupport()
  const [expiringDaysFilter] = useSettings('expiringDaysFilter')
  const { contract } = row
  const contractStatus = row.state

  //* contract support shown always, simple contract status check only
  const showContractSupport =
    contractStatus === ContractState.Running ||
    contractStatus === ContractState.Extended ||
    contractStatus === 'Expiring' ||
    contractStatus === ContractState.Initialized

  const contractForms =
    allOrdersForms?.filter((f) =>
      Orders.isFormAvailableForContractQuickAction(
        f,
        contract,
        Number(expiringDaysFilter),
        user,
        allTenants,
        filteredCustomers
      )
    ) ?? []
  const quickActions = [
    {
      form: undefined,
      label: t('SUPPORT_CONTRACT'),
    },
    ...contractForms.map((f) => {
      return { form: f, label: getFormTitle(f, i18n.language) }
    }),
  ].sort((a, b) => a.label.localeCompare(b.label))
  return (
    <>
      <NavLink to={`/generalContracts/details/${contract.id}`}>{contract.reference}</NavLink>
      {(contractForms.length > 0 || showContractSupport) && (
        <div className="quickActions">
          <div className="actionTrigger">
            <i className="icon-actions" />
            <i className="icon-bottom" />
          </div>
          <ul className="quickActionsList">
            {quickActions.map(({ form: f, label }, i) => {
              if (showContractSupport && label === t('SUPPORT_CONTRACT')) {
                return (
                  <li key={'contractIssue'}>
                    <a onClick={() => setContractSupportRef(contract.reference ?? '')}>
                      <i className={'icon-help'} /> {t('SUPPORT_CONTRACT')}
                    </a>
                  </li>
                )
              }
              if (!f) return
              return (
                <li key={i}>
                  <NavLink to={`/requests/new/${f.id}/contract/${contract.id}`} exact={true}>
                    <i className={f.icon || 'icon-order'} /> {label || f.id}
                  </NavLink>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </>
  )
}
